import React, { useEffect, useState } from 'react';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import EditIcon from "@mui/icons-material/Edit";
import Modal from "@mui/material/Modal";
import TablePagination from '@mui/material/TablePagination';
import { apiCall } from '../../services/authServieces';
import deleteIcon from '../../Assets/images/delete.png';

const AdminUserPercentageMapping = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);  
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const [adminList, setAdminList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedAdminId, setSelectedAdminId] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const [formData, setFormData] = useState({
    id: '',
    adminId: '',
    adminName: '',
    userId: '',
    userName: '',
    percentage: ''
  });

  useEffect(() => {
    fetchData();
    fetchAdminList();
  }, [page, rowsPerPage]);

  const fetchData = async () => {
    try {
      const response = await apiCall({
        endpoint: `admin/get-admin-user-percentage?page=${page + 1}&limit=${rowsPerPage}`,
        method: 'GET',
      });
      if (response && Array.isArray(response.data)) {
        setRows(response.data);
        setTotal(response.total || 0);
      } else {
        setRows([]);
        setTotal(0);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      setRows([]);
      setTotal(0);
    }
  };

  const fetchAdminList = async () => {
    try {
      const response = await apiCall({ endpoint: 'admin/get-all-admins', method: 'GET' });
      setAdminList(response?.data || []);
    } catch (err) {
      console.error('Error fetching admin list:', err);
      setAdminList([]);
    }
  };

  const fetchUsersByAdmin = async (adminId) => {
    if (!adminId) return setUserList([]);
    setLoadingUsers(true);
    try {
      const response = await apiCall({
        endpoint: `admin/get-users-by-admin/${adminId}`,
        method: 'GET',
      });
      setUserList(response?.data || []);
    } catch (err) {
      console.error('Error fetching users:', err);
      setUserList([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleAdminChange = (e) => {
    const adminId = e.target.value;
    setSelectedAdminId(adminId);
    setSelectedUserId('');

    const selectedAdmin = adminList.find(a => a.user_id === adminId);
    setFormData({ ...formData,
      adminId,
      adminName: selectedAdmin?.user_id || '',
      userId: '',
      userName: ''
    });
    fetchUsersByAdmin(adminId);
  };

 const handleUserChange = (e) => {
  const userId = e.target.value;

  const selectedUser = userList.find(user => user.user_id === userId);

  setSelectedUserId(userId);
  setFormData(prev => ({
    ...prev,
    userId: userId,
    userName: selectedUser ? selectedUser.user_id : ''
  }));
};


  const handlePercentageChange = (e) => {
    const val = e.target.value;
    if (val === '' || (/^\d{1,3}$/.test(val) && parseInt(val) <= 100)) {
      setFormData({ ...formData, percentage: val });
    }
  };

  const handleOpenModal = () => {
    setIsEditMode(false);
    setFormData({ id: '', adminId: '', adminName: '', userId: '', userName: '', percentage: '' });
    setSelectedAdminId('');
    setSelectedUserId('');
    setUserList([]);
    setIsModalOpen(true);
  };

  const handleEditRow = (row) => {
    setIsEditMode(true);
    setFormData({
      id: row.id,
      adminId: row.admin_id,
      adminName: row.admin_name,
      userId: row.user_id,
      userName: row.user_name,
      percentage: row.percentage,
    });
    setSelectedAdminId(row.admin_id);
    setSelectedUserId(row.user_id);
    fetchUsersByAdmin(row.admin_id);
    setIsModalOpen(true);
  };

  const handleDeleteRow = (row) => {
    setRowToDelete(row);
    setIsConfirmDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await apiCall({
        endpoint: 'admin/delete-admin-user-percentage',
        method: 'POST',
        payload: { id: rowToDelete.id },
      });
      fetchData();
    } catch (err) {
      console.error('Delete error:', err);
    }
    setIsConfirmDeleteModalOpen(false);
  };

  const handleSave = async () => {
    if (!selectedAdminId || !selectedUserId || formData.percentage === '') {
      return alert('All fields are required');
    }
    const perc = parseInt(formData.percentage);
    if (isNaN(perc) || perc < 0 || perc > 100) {
      return alert('Percentage must be 0–100');
    }

    const payload = {
      adminId: selectedAdminId,
      userId: selectedUserId,
      percentage: formData.percentage,
    };

    try {
      if (isEditMode) {
        await apiCall({
          endpoint: `admin/update-admin-user-percentage/${formData.id}`,
          method: 'PUT',
          payload,
        });
      } else {
        await apiCall({
          endpoint: 'admin/add-admin-user-percentage',
          method: 'POST',
          payload,
        });
      }
      fetchData();
      setIsModalOpen(false);
    } catch (err) {
      console.error('Save error:', err);
    }
  };

  return (
    <div className="WB_customize_contain">
      <h4 className="Head_title">
        Admin User Percentage Mapping
        <button type="button" className="add_btn6 add_country_btn" onClick={handleOpenModal}>
          <img alt="+" src="data:image/png;base64,iVBOR…" />
          Add Percentage
        </button>
      </h4>

      <Paper sx={{ width: '100%' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="mapping table">
            <TableHead>
              <TableRow>
                <TableCell>Admin Id</TableCell>
                <TableCell>User Id</TableCell>
                <TableCell>Percentage (%)</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length ? (
                rows.map((row, idx) => (
                  <TableRow key={idx} hover>
                    <TableCell>{row.admin_id}</TableCell>
                    <TableCell>{row.user_id}</TableCell>
                    <TableCell>{row.percentage}%</TableCell>
                    <TableCell>
                      <EditIcon onClick={() => handleEditRow(row)} style={{ cursor: 'pointer' }} />
                      <button onClick={() => handleDeleteRow(row)} className="ChatBotDeleteBtn">
                        <img src={deleteIcon} alt="Delete" />
                      </button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, p) => setPage(p)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>

      {/* Add/Edit Modal */}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} className='d-flex justify-content-center margin-auto'>
        <div className="modal_container bg-white w-50">
          <h2>{isEditMode ? 'Edit Percentage' : 'Add Percentage'}</h2>
          <div className="Customize_card">
            <div className="row gy-3">
              <div className="col-lg-6 form_group11">
                <label htmlFor="adminSelect">Select Admin *</label>
                <select
                  id="adminSelect"
                  className="form-select"
                  value={selectedAdminId}
                  onChange={handleAdminChange}
                  disabled={isEditMode}
                >
                  <option value="">Select Admin</option>
                  {adminList.map((a) => (
                    <option key={a.user_id} value={a.user_id}>
                      {a.user_id} 
                    </option>
                  ))}
                </select>
              </div>

             <div className="col-lg-6">
  <div className="form_group11">
    <label htmlFor="userSelect">
      Select User <span className="required_icon">*</span>
    </label>
   <select
  className="form-control"
  id="userSelect"
  value={selectedUserId}
  onChange={handleUserChange}
  disabled={!selectedAdminId || loadingUsers || isEditMode}
>
  <option value="">
    {loadingUsers ? 'Loading Users...' : 'Select User'}
  </option>
  {userList.map((user) => (
    <option key={user.user_id} value={user.user_id}>
      {user.user_id}
    </option>
  ))}
</select>
  </div>
</div>


              <div className="col-lg-12 form_group11">
                <label htmlFor="percentage">Percentage Share *</label>
                <input
                  type="number"
                  className="input_h_s"
                  id="percentage"
                  min="0"
                  max="100"
                  placeholder="Enter percentage (0–100)"
                  value={formData.percentage}
                  onChange={handlePercentageChange}
                />
                <small style={{ color: '#666', fontSize: '12px' }}>
                  Only whole numbers between 0 and 100
                </small>
              </div>
            </div>
          </div>

          <div className="btn_m_save">
            <button className="btn btn-primary" onClick={handleSave}>
              {isEditMode ? 'Update Percentage' : 'Add Percentage'}
            </button>
            <button className="btn btn-danger" onClick={() => setIsModalOpen(false)}>
              Close
            </button>
          </div>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        open={isConfirmDeleteModalOpen}
        onClose={() => setIsConfirmDeleteModalOpen(false)}
      >
        <div className="modal_container">
          <h2>Confirm Deletion</h2>
          <p>Are you sure you want to delete this percentage mapping?</p>
          <div className="btn_m_save">
            <button className="btn btn-danger" onClick={handleConfirmDelete}>
              Yes, Delete
            </button>
            <button className="btn btn-secondary" onClick={() => setIsConfirmDeleteModalOpen(false)}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <style>
        {`
        .modal_container {
        max-height: 400px;
    padding: 10px;
    margin: 100px auto;
    border-radius: 10px;
        }
    .btn_m_save{
    display: flex
;
    gap: 20px;
    }
        `}
      </style>
    </div>
  );
};

export default AdminUserPercentageMapping;
